import { call } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* getCompanies(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMPANIES.LIST, action.payload, true);
}

function* getCompanyDetails(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.COMPANIES.DETAILS(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.GET, url, rest, true);
}

function* updateUserStatus(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.COMPANIES.UPDATE_STATUS, action.payload, true);
}

function* updateVerifyEmail(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.COMPANIES.UPDATE_VERIFY, action.payload, true);
}

function* impersonateCompany(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.COMPANIES.IMPERSONATE(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.POST, url, rest, true);
}

function* getCompanyActivities(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMPANIES.ACTIVITIES, action.payload, true);
}

export default function* adminCompaniesSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.COMPANIES.LIST, getCompanies);
  yield takeLatest(SAGA_ACTIONS.ADMIN.COMPANIES.GET_DETAILS, getCompanyDetails);
  yield takeLatest(SAGA_ACTIONS.ADMIN.COMPANIES.UPDATE_STATUS, updateUserStatus);
  yield takeLatest(SAGA_ACTIONS.ADMIN.COMPANIES.UPDATE_VERIFY, updateVerifyEmail);
  yield takeLatest(SAGA_ACTIONS.ADMIN.COMPANIES.IMPERSONATE, impersonateCompany);
  yield takeLatest(SAGA_ACTIONS.ADMIN.COMPANIES.ACTIVITIES, getCompanyActivities);
}
